import { html } from '../html.js';
import { DEFAULT_PRINT_OPTIONS } from '../print-options.js';
import { t } from '../strings.js';
import { docDate, field, fields, footer, header, ltr } from './parts.js';
import { notesBlock, party, pricedLineTable, statusBadge, statusLabel, totalsBlock, } from './record-parts.js';
/**
 * PUR-03's purchase invoice (bill) as a printed document — the company's own
 * record of what the supplier charged, for the file and the auditor.
 *
 * Its own facts: the SUPPLIER'S INVOICE NUMBER (the document this one
 * records; a bill without it cannot be matched to the supplier's statement),
 * the DUE DATE the payment run keys on, and the purchase order it was raised
 * against when there was one.
 */
export function purchaseInvoiceHtml(data, locale, company, generatedAt, generatedBy, print = DEFAULT_PRINT_OPTIONS) {
    return html `
    ${header(company, t('purchaseInvoiceTitle', locale), statusBadge(data.status, locale))}
    ${fields([
        field(t('billNo', locale), ltr(data.code)),
        field(t('invoiceDate', locale), docDate(data.invoiceDate)),
        field(t('supplierCode', locale), ltr(data.partnerCode)),
        field(t('dueDate', locale), docDate(data.dueDate)),
        field(t('supplierInvoiceNo', locale), data.supplierInvoiceNo === null || data.supplierInvoiceNo.trim() === ''
            ? '—'
            : ltr(data.supplierInvoiceNo)),
        field(t('status', locale), statusLabel(data.status, locale)),
        ...(data.purchaseOrderCode === null
            ? []
            : [field(t('purchaseOrderRef', locale), ltr(data.purchaseOrderCode))]),
    ])}
    ${party(t('supplier', locale), data.partnerName)}
    ${pricedLineTable(data.lines, data.currency, locale, print)}
    ${totalsBlock(data, locale, print)}
    ${notesBlock(t('notes', locale), data.notes)}
    ${footer(locale, generatedAt, company.name, generatedBy)}
  `;
}
//# sourceMappingURL=purchase-invoice.js.map